import React, { useEffect, useState } from 'react';
import Button from "@mui/material/Button";
import VerifiedIcon from '@mui/icons-material/Verified'
import Dropdown from "react-bootstrap/Dropdown";
import { useLocation } from 'react-router-dom';
import {
    Card, CardContent, Typography, Grid, Chip, Avatar, Box, Divider, Stack, Paper
} from '@mui/material';
import NavBar from '../../structure/NavBar';
import { NavBarTop } from '../../structure/NavBarTop';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { updateTopHeader, updateLoading } from '../../../redux/features/common/commonSlice';
import urls from '../../constants/apiurl';
import ApiCaller from '../../constants/ApiCaller';
import { showDangerToast, showToast } from '../../constants/toaster';
import Utils from '../../constants/Utils';
import { FullImageView } from '../../custom/FullImageView';
import Image from '../../custom/Image';
const statusMenu = [{
    label: 'Submitted',
    value: 'SUBMITTED'
},
{
    label: 'Re-Submitted',
    value: 'RESUBMITTED'
}, {
    label: 'Approve',
    value: 'APPROVE'
}, {
    label: 'Reject',
    value: 'REJECT'
}

]
export const ViewRiderDetails = () => {
    const location = useLocation();
    const [statusDropdownText, setStatusDropdownText] = useState({ label: 'Submitted', value: 'SUBMITTED' });
    const [imageUrl, setImageUrl] = useState(false)
    const [displayAddress, setDisplayAddress] = useState('-')
    const [fullSizePreview, setFullSizePreview] = useState(false)
    const { formatDate, getAddressFromLatLng } = Utils();
    const { id } = useParams()
    const dispatch = useDispatch()
    const userData = useSelector(state => state?.userData)
    const [merchantDetailsData, setMerchantDetailsData] = useState({})
    const [userDetailsData, setUserDetailsData] = useState({})
    const [guarantorData, setGuarantorData] = useState({})
    const hiddenData = location.state?.hiddenData;

    useEffect(() => {
        dispatch(updateTopHeader('Riders Details'))
        if (id) {
            console.log(hiddenData)
            if (hiddenData?.userId) {
                getUserDetails(hiddenData?.userId)
                
                // Get guarantor details if available
                if (hiddenData?.guarantorNumber && hiddenData?.agentCode) {
                    getRiderGuarantorDetails(hiddenData?.agentCode, hiddenData?.guarantorNumber, hiddenData?.userId)
                }
                
                if (hiddenData?.statusType) {
                    if (hiddenData?.statusType === "SUBMITTED") {
                        setStatusDropdownText({
                            label: 'Submitted',
                            value: 'SUBMITTED'
                        })
                    } else if (hiddenData?.statusType === "RESUBMITTED") {
                        setStatusDropdownText({
                            label: 'Re-Submitted',
                            value: 'RESUBMITTED'
                        })
                    } else if (hiddenData?.statusType === "APPROVE") {
                        setStatusDropdownText({
                            label: 'Approve',
                            value: 'APPROVE'
                        })
                    } else if (hiddenData?.statusType === "REJECT") {
                        setStatusDropdownText({
                            label: 'Reject',
                            value: 'REJECT'
                        })
                    }
                }
            }
        } else {
            navigator('/riders-manager')
        }
    }, [id])


    const handleChangeStatus = async () => {
        try {
            dispatch(updateLoading(true))
            let postJson = {
                riderStatus: statusDropdownText?.value,
                id: id
            }
            let path = urls.updateRidersStatus
            let res = await ApiCaller.put(postJson, path, userData?.access_token)
            const response = await res.response.json()
            if (response.status == 200) {
                dispatch(updateLoading(false))
                // getMerchantBusinessDetails(response?.data)
                showToast(response.message)
            } else {
                dispatch(updateLoading(false))
                showDangerToast(response.message)
            }
        } catch (error) {
            dispatch(updateLoading(false))
            console.error(error)
            showDangerToast(error.message)
        }
    }

    const getRiderGuarantorDetails = async (agentCode, guarantorNumber, riderReelId) => {
        try {
            dispatch(updateLoading(true))
            let path = urls.getAgentGuarantorDetails + '?agentCode=' + agentCode + "&guarantorNumber=" + guarantorNumber + "&merchantReelId=" + riderReelId
            let res = await ApiCaller.get({}, path, userData?.access_token)
            const response = await res.response.json()
            if (response.status == 200) {
                dispatch(updateLoading(false))
                setGuarantorData(response?.data)
                console.log('Guarantor Data:', response?.data)
            } else {
                dispatch(updateLoading(false))
                showDangerToast(response.message)
            }
        } catch (error) {
            dispatch(updateLoading(false))
            console.error(error)
            showDangerToast(error.message)
        }
    }
    const getUserDetails = async (userId) => {
        try {
            dispatch(updateLoading(true))
            let path = urls.userDetails + '/' + userId
            let res = await ApiCaller.get({}, path, userData?.access_token)
            const response = await res.response.json()
            if (response.status == 200) {
                dispatch(updateLoading(false))
                setUserDetailsData(response?.data)
            } else {
                dispatch(updateLoading(false))
                showDangerToast(response.message)
            }
        } catch (error) {
            dispatch(updateLoading(false))
            console.error(error)
            showDangerToast(error.message)
        }
    }

    const redirectToGoogleMaps = (lat, lng) => {
        const url = `https://www.google.com/maps?q=${lat},${lng}`;
        window.open(url, '_blank');
    };


    return (
        <>
            <>
                <NavBar />
                <div className="main-content">
                    <NavBarTop />
                    <div className="header">
                        <div className="logo">
                            <div className="header bg-gradient-primary pb-8 ">
                            </div>
                        </div>
                    </div>
                    <Box sx={{ p: 2, mb: 2, bgcolor: '#f8f9fa', borderRadius: 2, border: '1px solid #e9ecef' }}>
                        <Grid container spacing={2} alignItems="center">
                            <Grid item xs={12} sm={6} md={3}>
                                <Typography variant="subtitle2" color="text.secondary" sx={{ mb: 1 }}>
                                    Update Status
                                </Typography>
                                <Dropdown>
                                    <Dropdown.Toggle
                                        variant="success"
                                        style={{
                                            backgroundColor: "white",
                                            color: "black",
                                            border: "1px solid #cad1d7",
                                            boxShadow: "none",
                                            transform: "none",
                                            minWidth: '150px'
                                        }}
                                        id="dropdown-basic"
                                    >
                                        {statusDropdownText?.label}
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu>
                                        {statusMenu?.map((menuItem, index) => (
                                            <Dropdown.Item
                                                key={index}
                                                onClick={() => setStatusDropdownText(menuItem)}
                                            >
                                                {menuItem?.label}
                                            </Dropdown.Item>
                                        ))}
                                    </Dropdown.Menu>
                                </Dropdown>
                            </Grid>
                            <Grid item xs={12} sm={6} md={3}>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={handleChangeStatus}
                                    sx={{
                                        minWidth: '120px',
                                        textTransform: 'none',
                                        borderRadius: 2,
                                        fontWeight: 600
                                    }}
                                >
                                    Update Status
                                </Button>
                            </Grid>
                        </Grid>
                    </Box>
                    <div style={{ padding: '1rem' }}>
                        {/* Personal Overview Section */}
                        <Card sx={{ mb: 3, borderRadius: 3, boxShadow: '0 4px 12px rgba(0,0,0,0.1)' }}>
                            <CardContent>
                                <Typography variant="h6" color="primary" fontWeight={600} gutterBottom>
                                    Rider Personal Overview
                                </Typography>
                                <Grid container spacing={3}>
                                    <Grid item xs={12} md={8}>
                                        <Grid container spacing={2}>
                                            <Grid item xs={12} sm={6} md={4}>
                                                <Box sx={{ p: 2, bgcolor: '#f8f9fa', borderRadius: 2, border: '1px solid #e9ecef' }}>
                                                    <Typography variant="subtitle2" color="text.secondary" sx={{ mb: 0.5 }}>
                                                        Username
                                                    </Typography>
                                                    <Typography variant="body1" fontWeight={500}>
                                                        {userDetailsData?.userName || '-'}
                                                    </Typography>
                                                </Box>
                                            </Grid>
                                            <Grid item xs={12} sm={6} md={4}>
                                                <Box sx={{ p: 2, bgcolor: '#f8f9fa', borderRadius: 2, border: '1px solid #e9ecef' }}>
                                                    <Typography variant="subtitle2" color="text.secondary" sx={{ mb: 0.5 }}>
                                                        USER ID
                                                    </Typography>
                                                    <Typography variant="body1" fontWeight={500}>
                                                        {userDetailsData?.chatUserId || '-'}
                                                    </Typography>
                                                </Box>
                                            </Grid>
                                            <Grid item xs={12} sm={6} md={4}>
                                                <Box sx={{ p: 2, bgcolor: '#f8f9fa', borderRadius: 2, border: '1px solid #e9ecef' }}>
                                                    <Typography variant="subtitle2" color="text.secondary" sx={{ mb: 0.5 }}>
                                                        Full Name
                                                    </Typography>
                                                    <Typography variant="body1" fontWeight={500}>
                                                        {userDetailsData?.fullName || '-'}
                                                    </Typography>
                                                </Box>
                                            </Grid>
                                            <Grid item xs={12} sm={6} md={4}>
                                                <Box sx={{ p: 2, bgcolor: '#f8f9fa', borderRadius: 2, border: '1px solid #e9ecef' }}>
                                                    <Typography variant="subtitle2" color="text.secondary" sx={{ mb: 0.5 }}>
                                                        Email
                                                    </Typography>
                                                    <Typography variant="body1" fontWeight={500}>
                                                        {userDetailsData?.email || '-'}
                                                    </Typography>
                                                </Box>
                                            </Grid>
                                            <Grid item xs={12} sm={6} md={4}>
                                                <Box sx={{ p: 2, bgcolor: '#f8f9fa', borderRadius: 2, border: '1px solid #e9ecef' }}>
                                                    <Typography variant="subtitle2" color="text.secondary" sx={{ mb: 0.5 }}>
                                                        Mobile
                                                    </Typography>
                                                    <Typography variant="body1" fontWeight={500}>
                                                        {userDetailsData?.ext} {userDetailsData?.contactNumber || '-'}
                                                    </Typography>
                                                </Box>
                                            </Grid>
                                            <Grid item xs={12} sm={6} md={4}>
                                                <Box sx={{ p: 2, bgcolor: '#f8f9fa', borderRadius: 2, border: '1px solid #e9ecef' }}>
                                                    <Typography variant="subtitle2" color="text.secondary" sx={{ mb: 0.5 }}>
                                                        Gender
                                                    </Typography>
                                                    <Typography variant="body1" fontWeight={500}>
                                                        {userDetailsData?.gender || '-'}
                                                    </Typography>
                                                </Box>
                                            </Grid>
                                            <Grid item xs={12} sm={6} md={4}>
                                                <Box sx={{ p: 2, bgcolor: '#f8f9fa', borderRadius: 2, border: '1px solid #e9ecef' }}>
                                                    <Typography variant="subtitle2" color="text.secondary" sx={{ mb: 0.5 }}>
                                                        Date Of Birth
                                                    </Typography>
                                                    <Typography variant="body1" fontWeight={500}>
                                                        {userDetailsData?.dob || '-'}
                                                    </Typography>
                                                </Box>
                                            </Grid>
                                            <Grid item xs={12} sm={6} md={4}>
                                                <Box sx={{ p: 2, bgcolor: '#f8f9fa', borderRadius: 2, border: '1px solid #e9ecef' }}>
                                                    <Typography variant="subtitle2" color="text.secondary" sx={{ mb: 0.5 }}>
                                                        Registration Date
                                                    </Typography>
                                                    <Typography variant="body1" fontWeight={500}>
                                                        {formatDate(userDetailsData?.createdAt) || '-'}
                                                    </Typography>
                                                </Box>
                                            </Grid>
                                            <Grid item xs={12} sm={6} md={4}>
                                                <Box sx={{ p: 2, bgcolor: '#f8f9fa', borderRadius: 2, border: '1px solid #e9ecef' }}>
                                                    <Typography variant="subtitle2" color="text.secondary" sx={{ mb: 0.5 }}>
                                                        Exclusive Enable
                                                    </Typography>
                                                    <Typography variant="body1" fontWeight={500}>
                                                        {userDetailsData?.exclusiveEnable ? (
                                                            <Chip label="Enabled" color="success" size="small" />
                                                        ) : (
                                                            <Chip label="Disabled" color="default" size="small" />
                                                        )}
                                                    </Typography>
                                                </Box>
                                            </Grid>
                                            <Grid item xs={12} sm={6} md={4}>
                                                <Box sx={{ p: 2, bgcolor: '#f8f9fa', borderRadius: 2, border: '1px solid #e9ecef' }}>
                                                    <Typography variant="subtitle2" color="text.secondary" sx={{ mb: 0.5 }}>
                                                        Account Type
                                                    </Typography>
                                                    <Typography variant="body1" fontWeight={500}>
                                                        {userDetailsData?.accountType || '-'}
                                                    </Typography>
                                                </Box>
                                            </Grid>
                                            <Grid item xs={12} sm={6} md={4}>
                                                <Box sx={{ p: 2, bgcolor: '#f8f9fa', borderRadius: 2, border: '1px solid #e9ecef' }}>
                                                    <Typography variant="subtitle2" color="text.secondary" sx={{ mb: 0.5 }}>
                                                        Register Via
                                                    </Typography>
                                                    <Typography variant="body1" fontWeight={500}>
                                                        {userDetailsData?.signInType || '-'}
                                                    </Typography>
                                                </Box>
                                            </Grid>
                                            <Grid item xs={12} sm={6} md={4}>
                                                <Box sx={{ p: 2, bgcolor: '#f8f9fa', borderRadius: 2, border: '1px solid #e9ecef' }}>
                                                    <Typography variant="subtitle2" color="text.secondary" sx={{ mb: 0.5 }}>
                                                        Total Chips
                                                    </Typography>
                                                    <Typography variant="body1" fontWeight={500}>
                                                        {userDetailsData?.totalChipsBalance || '0'}
                                                    </Typography>
                                                </Box>
                                            </Grid>
                                            <Grid item xs={12}>
                                                <Box sx={{ p: 2, bgcolor: '#f8f9fa', borderRadius: 2, border: '1px solid #e9ecef' }}>
                                                    <Typography variant="subtitle2" color="text.secondary" sx={{ mb: 0.5 }}>
                                                        Categories
                                                    </Typography>
                                                    <Typography variant="body1" fontWeight={500}>
                                                        {userDetailsData?.userPreferredTags?.join(", ") || '-'}
                                                    </Typography>
                                                </Box>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                    <Grid item xs={12} md={4}>
                                        <Card sx={{ borderRadius: 3, boxShadow: '0 4px 12px rgba(0,0,0,0.1)' }}>
                                            <CardContent>
                                                <Box display="flex" flexDirection="column" alignItems="center" sx={{ p: 2 }}>
                                                    <Avatar
                                                        src={userDetailsData?.profilePic}
                                                        alt={userDetailsData?.fullName}
                                                        sx={{
                                                            width: 120,
                                                            height: 120,
                                                            mb: 2,
                                                            cursor: 'pointer',
                                                            border: '3px solid #e3f2fd',
                                                            boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
                                                            transition: 'all 0.3s ease',
                                                            '&:hover': {
                                                                transform: 'scale(1.05)',
                                                                boxShadow: '0 6px 20px rgba(0,0,0,0.15)'
                                                            }
                                                        }}
                                                        onClick={() => {
                                                            setFullSizePreview(!fullSizePreview)
                                                            setImageUrl(userDetailsData?.profilePic)
                                                        }}
                                                    />
                                                    {userDetailsData?.isBadged && (
                                                        <Box sx={{ position: 'absolute', top: 100, right: 'calc(50% - 80px)' }}>
                                                            <VerifiedIcon sx={{ color: '#1976d2', fontSize: 30 }} />
                                                        </Box>
                                                    )}
                                                    <Typography variant="h5" fontWeight={600} textAlign="center" sx={{ mb: 1 }}>
                                                        {userDetailsData?.fullName || 'Unknown'}
                                                    </Typography>
                                                    <Typography variant="body2" color="text.secondary" textAlign="center" sx={{ mb: 2 }}>
                                                        @{userDetailsData?.userName || 'username'}
                                                    </Typography>
                                                    <Grid container spacing={1} sx={{ mb: 2 }}>
                                                        <Grid item xs={6} textAlign="center">
                                                            <Typography variant="h6" fontWeight={600}>
                                                                {userDetailsData?.totalFollowers || 0}
                                                            </Typography>
                                                            <Typography variant="caption" color="text.secondary">
                                                                Followers
                                                            </Typography>
                                                        </Grid>
                                                        <Grid item xs={6} textAlign="center">
                                                            <Typography variant="h6" fontWeight={600}>
                                                                {userDetailsData?.totalFollowing || 0}
                                                            </Typography>
                                                            <Typography variant="caption" color="text.secondary">
                                                                Following
                                                            </Typography>
                                                        </Grid>
                                                        <Grid item xs={6} textAlign="center">
                                                            <Typography variant="h6" fontWeight={600}>
                                                                {userDetailsData?.totalVideos || 0}
                                                            </Typography>
                                                            <Typography variant="caption" color="text.secondary">
                                                                Videos
                                                            </Typography>
                                                        </Grid>
                                                        <Grid item xs={6} textAlign="center">
                                                            <Typography variant="h6" fontWeight={600}>
                                                                {userDetailsData?.totalLikes || 0}
                                                            </Typography>
                                                            <Typography variant="caption" color="text.secondary">
                                                                Likes
                                                            </Typography>
                                                        </Grid>
                                                    </Grid>
                                                    {userDetailsData?.bio && (
                                                        <Typography variant="body2" color="text.secondary" textAlign="center">
                                                            {userDetailsData.bio}
                                                        </Typography>
                                                    )}
                                                </Box>
                                            </CardContent>
                                        </Card>
                                    </Grid>
                                </Grid>
                            </CardContent>
                        </Card>

                        {/* Rider Application Details Section */}
                        {hiddenData && (
                            <Card sx={{ mb: 3, borderRadius: 3, boxShadow: '0 4px 12px rgba(0,0,0,0.1)', overflow: 'hidden' }}>
                                <CardContent sx={{ p: 0 }}>
                                    {/* Header Section */}
                                    <Box sx={{
                                        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                                        color: 'white',
                                        p: 3
                                    }}>
                                        <Grid container alignItems="center" justifyContent="space-between">
                                            <Grid item>
                                                <Typography variant="h5" fontWeight={700} gutterBottom>
                                                    Rider Application Details
                                                </Typography>
                                                <Chip
                                                    label={hiddenData?.statusType || 'SUBMITTED'}
                                                    sx={{
                                                        bgcolor: hiddenData?.statusType === 'APPROVE' ? '#4caf50' :
                                                            hiddenData?.statusType === 'REJECT' ? '#f44336' : '#ff9800',
                                                        color: 'white',
                                                        fontWeight: 600
                                                    }}
                                                />
                                            </Grid>
                                        </Grid>
                                    </Box>

                                    {/* Application Details Content */}
                                    <Box sx={{ p: 3 }}>
                                        <Grid container spacing={3}>
                                            {/* Application Info Section */}
                                            <Grid item xs={12} md={8}>
                                                <Box sx={{ mb: 3 }}>
                                                    <Typography variant="h6" color="primary" fontWeight={600} gutterBottom>
                                                        Application Information
                                                    </Typography>
                                                    <Grid container spacing={2}>
                                                        <Grid item xs={12} sm={6} md={4}>
                                                            <Box sx={{ p: 2, bgcolor: '#e8f5e8', borderRadius: 2, border: '1px solid #4caf50' }}>
                                                                <Typography variant="subtitle2" color="text.secondary" sx={{ mb: 0.5 }}>
                                                                    Rider Code
                                                                </Typography>
                                                                <Typography variant="body1" fontWeight={500}>
                                                                    {hiddenData?.code || '-'}
                                                                </Typography>
                                                            </Box>
                                                        </Grid>
                                                        <Grid item xs={12} sm={6} md={4}>
                                                            <Box sx={{ p: 2, bgcolor: '#fff3e0', borderRadius: 2, border: '1px solid #ff9800' }}>
                                                                <Typography variant="subtitle2" color="text.secondary" sx={{ mb: 0.5 }}>
                                                                    Document ID
                                                                </Typography>
                                                                <Typography variant="body1" fontWeight={500}>
                                                                    {hiddenData?.documentId || '-'}
                                                                </Typography>
                                                            </Box>
                                                        </Grid>
                                                        <Grid item xs={12} sm={6} md={4}>
                                                            <Box sx={{ p: 2, bgcolor: '#e3f2fd', borderRadius: 2, border: '1px solid #2196f3' }}>
                                                                <Typography variant="subtitle2" color="text.secondary" sx={{ mb: 0.5 }}>
                                                                    Application Date
                                                                </Typography>
                                                                <Typography variant="body1" fontWeight={500}>
                                                                    {formatDate(hiddenData?.createdAt) || '-'}
                                                                </Typography>
                                                            </Box>
                                                        </Grid>
                                                        <Grid item xs={12} sm={6} md={4}>
                                                            <Box sx={{ p: 2, bgcolor: '#fce4ec', borderRadius: 2, border: '1px solid #e91e63' }}>
                                                                <Typography variant="subtitle2" color="text.secondary" sx={{ mb: 0.5 }}>
                                                                    Vehicle Name
                                                                </Typography>
                                                                <Typography variant="body1" fontWeight={500}>
                                                                    {hiddenData?.vehicleName || '-'}
                                                                </Typography>
                                                            </Box>
                                                        </Grid>
                                                        <Grid item xs={12} sm={6} md={4}>
                                                            <Box sx={{ p: 2, bgcolor: '#f3e5f5', borderRadius: 2, border: '1px solid #9c27b0' }}>
                                                                <Typography variant="subtitle2" color="text.secondary" sx={{ mb: 0.5 }}>
                                                                    Delivery Price
                                                                </Typography>
                                                                <Typography variant="body1" fontWeight={500}>
                                                                    {hiddenData?.price ? `$${hiddenData.price}` : '-'}
                                                                </Typography>
                                                            </Box>
                                                        </Grid>
                                                        <Grid item xs={12} sm={6} md={4}>
                                                            <Box sx={{ p: 2, bgcolor: '#e8f4fd', borderRadius: 2, border: '1px solid #0288d1' }}>
                                                                <Typography variant="subtitle2" color="text.secondary" sx={{ mb: 0.5 }}>
                                                                    Distance from Merchant
                                                                </Typography>
                                                                <Typography variant="body1" fontWeight={500}>
                                                                    {hiddenData?.distanceFromMerchant ? `${hiddenData.distanceFromMerchant} km` : 'Not calculated'}
                                                                </Typography>
                                                            </Box>
                                                        </Grid>
                                                        {hiddenData?.agentCode && (
                                                            <Grid item xs={12} sm={6} md={4}>
                                                                <Box sx={{ p: 2, bgcolor: '#fff8e1', borderRadius: 2, border: '1px solid #ffab00' }}>
                                                                    <Typography variant="subtitle2" color="text.secondary" sx={{ mb: 0.5 }}>
                                                                        Agent Code
                                                                    </Typography>
                                                                    <Typography variant="body1" fontWeight={500}>
                                                                        {hiddenData?.agentCode || 'Not Assigned'}
                                                                    </Typography>
                                                                </Box>
                                                            </Grid>
                                                        )}
                                                        {hiddenData?.guarantorNumber && (
                                                            <Grid item xs={12} sm={6} md={4}>
                                                                <Box sx={{ p: 2, bgcolor: '#fce4ec', borderRadius: 2, border: '1px solid #e91e63' }}>
                                                                    <Typography variant="subtitle2" color="text.secondary" sx={{ mb: 0.5 }}>
                                                                        Guarantor Number
                                                                    </Typography>
                                                                    <Typography variant="body1" fontWeight={500}>
                                                                        {hiddenData?.guarantorNumber || 'Not Assigned'}
                                                                    </Typography>
                                                                </Box>
                                                            </Grid>
                                                        )}
                                                        <Grid item xs={12} sm={6}>
                                                            <Box sx={{ p: 2, bgcolor: '#fff8e1', borderRadius: 2, border: '1px solid #ffc107' }}>
                                                                <Typography variant="subtitle2" color="text.secondary" sx={{ mb: 0.5 }}>
                                                                    Latitude
                                                                </Typography>
                                                                <Typography variant="body1" fontWeight={500}>
                                                                    {hiddenData?.lat || '-'}
                                                                </Typography>
                                                            </Box>
                                                        </Grid>
                                                        <Grid item xs={12} sm={6}>
                                                            <Box sx={{ p: 2, bgcolor: '#f1f8e9', borderRadius: 2, border: '1px solid #8bc34a' }}>
                                                                <Typography variant="subtitle2" color="text.secondary" sx={{ mb: 0.5 }}>
                                                                    Longitude
                                                                </Typography>
                                                                <Typography variant="body1" fontWeight={500}>
                                                                    {hiddenData?.lng || '-'}
                                                                </Typography>
                                                            </Box>
                                                        </Grid>
                                                        <Grid item xs={12}>
                                                            <Box sx={{ p: 2, bgcolor: '#e8f4fd', borderRadius: 2, border: '1px solid #0288d1' }}>
                                                                <Typography variant="subtitle2" color="text.secondary" sx={{ mb: 0.5 }}>
                                                                    Location
                                                                </Typography>
                                                                <Typography 
                                                                    variant="body1" 
                                                                    fontWeight={500}
                                                                    sx={{ 
                                                                        color: '#1976d2', 
                                                                        cursor: 'pointer',
                                                                        textDecoration: 'underline',
                                                                        '&:hover': { color: '#0d47a1' }
                                                                    }}
                                                                    onClick={() => redirectToGoogleMaps(hiddenData?.lat, hiddenData?.lng)}
                                                                >
                                                                    View on Google Maps
                                                                </Typography>
                                                            </Box>
                                                        </Grid>
                                                    </Grid>
                                                </Box>
                                            </Grid>

                                            {/* Documents Section */}
                                            <Grid item xs={12} md={4}>
                                                <Box>
                                                    <Typography variant="h6" color="primary" fontWeight={600} gutterBottom>
                                                        Verification Documents
                                                    </Typography>
                                                    <Stack spacing={3}>
                                                        {/* Live Selfie */}
                                                        <Box textAlign="center">
                                                            <Typography variant="subtitle1" fontWeight={600} sx={{ mb: 1 }}>
                                                                Live Selfie
                                                            </Typography>
                                                            {hiddenData?.liveSelfie ? (
                                                                <Box
                                                                    sx={{
                                                                        p: 1,
                                                                        border: '2px solid #e8f5e8',
                                                                        borderRadius: 2,
                                                                        bgcolor: '#fafafa',
                                                                        cursor: 'pointer',
                                                                        transition: 'all 0.3s ease',
                                                                        '&:hover': {
                                                                            boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                                                                            transform: 'translateY(-2px)'
                                                                        }
                                                                    }}
                                                                    onClick={() => {
                                                                        setFullSizePreview(!fullSizePreview)
                                                                        setImageUrl(hiddenData?.liveSelfie)
                                                                    }}
                                                                >
                                                                    <img
                                                                        src={hiddenData.liveSelfie}
                                                                        alt="Live Selfie"
                                                                        style={{ width: '100%', height: 120, objectFit: 'cover', borderRadius: 8 }}
                                                                    />
                                                                </Box>
                                                            ) : (
                                                                <Box sx={{
                                                                    width: '100%',
                                                                    height: 120,
                                                                    bgcolor: '#f5f5f5',
                                                                    borderRadius: 2,
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    justifyContent: 'center',
                                                                    color: '#aaa',
                                                                    border: '1px dashed #ccc'
                                                                }}>
                                                                    No Document Provided
                                                                </Box>
                                                            )}
                                                        </Box>

                                                        {/* Document ID */}
                                                        <Box textAlign="center">
                                                            <Typography variant="subtitle1" fontWeight={600} sx={{ mb: 1 }}>
                                                                Document ID
                                                            </Typography>
                                                            {hiddenData?.documentUrl ? (
                                                                <Box
                                                                    sx={{
                                                                        p: 1,
                                                                        border: '2px solid #e3f2fd',
                                                                        borderRadius: 2,
                                                                        bgcolor: '#fafafa',
                                                                        cursor: 'pointer',
                                                                        transition: 'all 0.3s ease',
                                                                        '&:hover': {
                                                                            boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                                                                            transform: 'translateY(-2px)'
                                                                        }
                                                                    }}
                                                                    onClick={() => {
                                                                        setFullSizePreview(!fullSizePreview)
                                                                        setImageUrl(hiddenData?.documentUrl)
                                                                    }}
                                                                >
                                                                    <img
                                                                        src={hiddenData.documentUrl}
                                                                        alt="Document ID"
                                                                        style={{ width: '100%', height: 120, objectFit: 'cover', borderRadius: 8 }}
                                                                    />
                                                                </Box>
                                                            ) : (
                                                                <Box sx={{
                                                                    width: '100%',
                                                                    height: 120,
                                                                    bgcolor: '#f5f5f5',
                                                                    borderRadius: 2,
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    justifyContent: 'center',
                                                                    color: '#aaa',
                                                                    border: '1px dashed #ccc'
                                                                }}>
                                                                    No Document Provided
                                                                </Box>
                                                            )}
                                                        </Box>

                                                        {/* Vehicle Image */}
                                                        {hiddenData?.vehicleImage && (
                                                            <Box textAlign="center">
                                                                <Typography variant="subtitle1" fontWeight={600} sx={{ mb: 1 }}>
                                                                    Vehicle Image
                                                                </Typography>
                                                                <Box
                                                                    sx={{
                                                                        p: 1,
                                                                        border: '2px solid #fce4ec',
                                                                        borderRadius: 2,
                                                                        bgcolor: '#fafafa',
                                                                        cursor: 'pointer',
                                                                        transition: 'all 0.3s ease',
                                                                        '&:hover': {
                                                                            boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                                                                            transform: 'translateY(-2px)'
                                                                        }
                                                                    }}
                                                                    onClick={() => {
                                                                        setFullSizePreview(!fullSizePreview)
                                                                        setImageUrl(hiddenData?.vehicleImage)
                                                                    }}
                                                                >
                                                                    <img
                                                                        src={hiddenData.vehicleImage}
                                                                        alt="Vehicle"
                                                                        style={{ width: '100%', height: 120, objectFit: 'cover', borderRadius: 8 }}
                                                                    />
                                                                </Box>
                                                            </Box>
                                                        )}

                                                        {/* Live Video */}
                                                        {hiddenData?.liveVideo && (
                                                            <Box textAlign="center">
                                                                <Typography variant="subtitle1" fontWeight={600} sx={{ mb: 1 }}>
                                                                    Live Video
                                                                </Typography>
                                                                <Box
                                                                    sx={{
                                                                        p: 1,
                                                                        border: '2px solid #fff3e0',
                                                                        borderRadius: 2,
                                                                        bgcolor: '#fafafa',
                                                                        cursor: 'pointer',
                                                                        transition: 'all 0.3s ease',
                                                                        '&:hover': {
                                                                            boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                                                                            transform: 'translateY(-2px)'
                                                                        }
                                                                    }}
                                                                    onClick={() => {
                                                                        setFullSizePreview(!fullSizePreview)
                                                                        setImageUrl(hiddenData?.liveVideo)
                                                                    }}
                                                                >
                                                                    <video
                                                                        src={hiddenData.liveVideo}
                                                                        style={{ width: '100%', height: 120, objectFit: 'cover', borderRadius: 8 }}
                                                                        controls={false}
                                                                        muted
                                                                    />
                                                                </Box>
                                                            </Box>
                                                        )}
                                                    </Stack>
                                                </Box>
                                            </Grid>
                                        </Grid>
                                    </Box>
                                </CardContent>
                            </Card>
                        )}

                        {/* Guarantor Details Section */}
                        {guarantorData && Object.keys(guarantorData).length > 0 && (
                            <Card sx={{ mb: 3, borderRadius: 3, boxShadow: '0 4px 12px rgba(0,0,0,0.1)', overflow: 'hidden' }}>
                                <CardContent sx={{ p: 0 }}>
                                    {/* Header Section */}
                                    <Box sx={{
                                        background: 'linear-gradient(135deg, #ff6b6b 0%, #ee5a24 100%)',
                                        color: 'white',
                                        p: 3
                                    }}>
                                        <Typography variant="h5" fontWeight={700} gutterBottom>
                                            Guarantor Details
                                        </Typography>
                                        <Typography variant="body2" sx={{ opacity: 0.9 }}>
                                            Information about the rider's guarantor
                                        </Typography>
                                    </Box>

                                    {/* Guarantor Details Content */}
                                    <Box sx={{ p: 3 }}>
                                        <Grid container spacing={3}>
                                            <Grid item xs={12} md={8}>
                                                <Grid container spacing={2}>
                                                    {guarantorData?.fullName && (
                                                        <Grid item xs={12} sm={6} md={4}>
                                                            <Box sx={{ p: 2, bgcolor: '#e8f5e8', borderRadius: 2, border: '1px solid #4caf50' }}>
                                                                <Typography variant="subtitle2" color="text.secondary" sx={{ mb: 0.5 }}>
                                                                    Full Name
                                                                </Typography>
                                                                <Typography variant="body1" fontWeight={500}>
                                                                    {guarantorData.fullName}
                                                                </Typography>
                                                            </Box>
                                                        </Grid>
                                                    )}
                                                    {guarantorData?.email && (
                                                        <Grid item xs={12} sm={6} md={4}>
                                                            <Box sx={{ p: 2, bgcolor: '#e3f2fd', borderRadius: 2, border: '1px solid #2196f3' }}>
                                                                <Typography variant="subtitle2" color="text.secondary" sx={{ mb: 0.5 }}>
                                                                    Email
                                                                </Typography>
                                                                <Typography variant="body1" fontWeight={500}>
                                                                    {guarantorData.email}
                                                                </Typography>
                                                            </Box>
                                                        </Grid>
                                                    )}
                                                    {guarantorData?.contactNumber && (
                                                        <Grid item xs={12} sm={6} md={4}>
                                                            <Box sx={{ p: 2, bgcolor: '#fff3e0', borderRadius: 2, border: '1px solid #ff9800' }}>
                                                                <Typography variant="subtitle2" color="text.secondary" sx={{ mb: 0.5 }}>
                                                                    Contact Number
                                                                </Typography>
                                                                <Typography variant="body1" fontWeight={500}>
                                                                    {guarantorData.ext} {guarantorData.contactNumber}
                                                                </Typography>
                                                            </Box>
                                                        </Grid>
                                                    )}
                                                    {guarantorData?.address && (
                                                        <Grid item xs={12}>
                                                            <Box sx={{ p: 2, bgcolor: '#f3e5f5', borderRadius: 2, border: '1px solid #9c27b0' }}>
                                                                <Typography variant="subtitle2" color="text.secondary" sx={{ mb: 0.5 }}>
                                                                    Address
                                                                </Typography>
                                                                <Typography variant="body1" fontWeight={500}>
                                                                    {guarantorData.address}
                                                                </Typography>
                                                            </Box>
                                                        </Grid>
                                                    )}
                                                </Grid>
                                            </Grid>
                                            <Grid item xs={12} md={4}>
                                                {guarantorData?.profilePic && (
                                                    <Box textAlign="center">
                                                        <Typography variant="h6" color="primary" fontWeight={600} gutterBottom>
                                                            Guarantor Profile
                                                        </Typography>
                                                        <Box
                                                            sx={{
                                                                p: 1,
                                                                border: '2px solid #e91e63',
                                                                borderRadius: 2,
                                                                bgcolor: '#fafafa',
                                                                cursor: 'pointer',
                                                                transition: 'all 0.3s ease',
                                                                '&:hover': {
                                                                    boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                                                                    transform: 'translateY(-2px)'
                                                                }
                                                            }}
                                                            onClick={() => {
                                                                setFullSizePreview(!fullSizePreview)
                                                                setImageUrl(guarantorData?.profilePic)
                                                            }}
                                                        >
                                                            <img
                                                                src={guarantorData.profilePic}
                                                                alt="Guarantor Profile"
                                                                style={{ width: '100%', height: 200, objectFit: 'cover', borderRadius: 8 }}
                                                            />
                                                        </Box>
                                                    </Box>
                                                )}
                                            </Grid>
                                        </Grid>
                                    </Box>
                                </CardContent>
                            </Card>
                        )}

                    </div>
                    <FullImageView
                        src={imageUrl}
                        show={fullSizePreview}
                        onHide={() => setFullSizePreview(false)}
                    />
                </div>
            </>
        </>
    );

}